import * as React from 'react';
import * as classNames from 'classnames';
import {StatelessComponent} from 'react';
import './styles.sass';

interface IVideoSettingsColumnProps {
  children?: any;
  size?: number;
}

export const VideoSettingsColumn: StatelessComponent<IVideoSettingsColumnProps> = ({
  children,
  size,
}) => (
  <div className={
    classNames('video-settings-column', {[`video-settings-column_size-${size}`]: size})
  }>
    {children}
  </div>
);
